import { render, staticRenderFns } from "./supplierPerformance.vue?vue&type=template&id=a94534a2&scoped=true&"
import script from "./supplierPerformance.vue?vue&type=script&lang=js&"
export * from "./supplierPerformance.vue?vue&type=script&lang=js&"
import style0 from "./supplierPerformance.vue?vue&type=style&index=0&id=a94534a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94534a2",
  null
  
)

export default component.exports